import { Box, Stack, Typography } from '@mui/material'
import { FC } from 'react'
import type { ToGeoJSON } from '@/types/apiModels'

type StratificationQUsSOCStrataProps = {
  samplingAreas: ToGeoJSON[]
}

export const StratificationQUsSOCStrata: FC<StratificationQUsSOCStrataProps> = ({
  samplingAreas,
}) => {
  return (
    <Stack spacing={1}>
      <Typography fontWeight="medium" variant="subtitle2">
        Estratos SOC
      </Typography>
      {samplingAreas.length === 0 ? (
        <Typography color="text.secondary" variant="body2">
          Sin estratos asociados
        </Typography>
      ) : (
        samplingAreas.map(area => (
          <Stack key={area.properties.id} alignItems="center" direction="row" spacing={1}>
            <Box
              sx={{
                backgroundColor: area.properties.color ?? 'grey.400',
                borderRadius: '50%',
                flexShrink: 0,
                height: 10,
                width: 10,
              }}
            />
            <Typography sx={{ flexGrow: 1 }} variant="body2">
              {area.properties.name}
            </Typography>
            <Typography color="text.secondary" variant="body2">
              {area.properties.area != null
                ? `${(area.properties.area as number).toFixed(2)} ha`
                : '- ha'}
            </Typography>
          </Stack>
        ))
      )}
    </Stack>
  )
}
